import React, { useEffect, useState } from 'react';
import { dateToUTCTime, dateToUTCDate } from '../../../../utils/DateTimeUtils';
import ClockWrapper from './ClockWrapper';

export interface ClockProps {
  mode: 'dateTime' | 'timeOnly' | 'dateOnly';
}

const Clock = (props: ClockProps) => {
  const { mode } = props;
  const [clockState, setClockState] = useState<{ [current: string]: Date }>({ current: new Date() });

  // Clear it when it unmounts
  useEffect(() => {
    // Increrment the date every second
    let intervalId: number = 0;
    intervalId = window.setInterval(() => {
      setClockState({ current: new Date() });
    }, 1000);
    return function() {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, []);

  let finalString = '';
  if (mode === 'dateTime') {
    const dateString = dateToUTCDate(clockState.current);
    const timeString = dateToUTCTime(clockState.current);
    finalString = `${dateString} ${timeString} UTC`;
  } else if (mode === 'timeOnly') {
    const timeString = dateToUTCTime(clockState.current);
    finalString = `${timeString} UTC`;
  } else if (mode === 'dateOnly') {
    const dateString = dateToUTCDate(clockState.current);
    finalString = dateString;
  }

  return <ClockWrapper>{finalString}</ClockWrapper>;
};

export default Clock;
